import React from 'react';
import ConsultaAssinante from './ConsultaAssinante';
import Retirada from './Retirada';

const Home = () => {
    const [assinante, setAssinante] = React.useState();
    return (
        <>
            {/*!pontoTroca && <PontoTroca onSelecionar={setPontoTroca} />*/}
            {!assinante && (
                <ConsultaAssinante onConsultarAssinante={setAssinante} />
            )}
            {assinante && (
                <Retirada assinante={assinante} onFinalizar={setAssinante} />
            )}
        </>
    );
};

export default Home;
